module.exports = __webpack_public_path__ + "static/media/mpi_bck.c8899665.png";